import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export var AdditionalInterestType;
(function (AdditionalInterestType) {
    AdditionalInterestType["GovernmentMunicipality"] = "GovernmentMunicipality";
    AdditionalInterestType["HomeownersAssociation"] = "HomeownersAssociation";
    AdditionalInterestType["Lienholder"] = "Lienholder";
    AdditionalInterestType["NotListed"] = "NotListed";
    AdditionalInterestType["PropertyManagerParkOwner"] = "PropertyManagerParkOwner";
})(AdditionalInterestType || (AdditionalInterestType = {}));
export var AllOtherPerilsDeductible;
(function (AllOtherPerilsDeductible) {
    AllOtherPerilsDeductible["Dollars1K"] = "Dollars1K";
    AllOtherPerilsDeductible["Dollars2K500"] = "Dollars2K500";
    AllOtherPerilsDeductible["Dollars5K"] = "Dollars5K";
    AllOtherPerilsDeductible["Dollars10K"] = "Dollars10K";
    AllOtherPerilsDeductible["Dollars500"] = "Dollars500";
})(AllOtherPerilsDeductible || (AllOtherPerilsDeductible = {}));
export var BurglarAlarmValue;
(function (BurglarAlarmValue) {
    BurglarAlarmValue["Local"] = "Local";
    BurglarAlarmValue["Monitored"] = "Monitored";
    BurglarAlarmValue["No"] = "No";
})(BurglarAlarmValue || (BurglarAlarmValue = {}));
export var CoverageAnimalLiabilityValue;
(function (CoverageAnimalLiabilityValue) {
    CoverageAnimalLiabilityValue["Dollars10K"] = "Dollars10K";
    CoverageAnimalLiabilityValue["Dollars25K"] = "Dollars25K";
    CoverageAnimalLiabilityValue["Dollars50K"] = "Dollars50K";
    CoverageAnimalLiabilityValue["Dollars100K"] = "Dollars100K";
    CoverageAnimalLiabilityValue["Dollars300K"] = "Dollars300K";
    CoverageAnimalLiabilityValue["Dollars500K"] = "Dollars500K";
    CoverageAnimalLiabilityValue["Excluded"] = "Excluded";
})(CoverageAnimalLiabilityValue || (CoverageAnimalLiabilityValue = {}));
export var CoverageDLossOfUseValue;
(function (CoverageDLossOfUseValue) {
    CoverageDLossOfUseValue["Percent10"] = "Percent10";
    CoverageDLossOfUseValue["Percent20"] = "Percent20";
    CoverageDLossOfUseValue["Percent30"] = "Percent30";
    CoverageDLossOfUseValue["Percent40"] = "Percent40";
})(CoverageDLossOfUseValue || (CoverageDLossOfUseValue = {}));
export var CoverageDamageToPropertyOfOthersValue;
(function (CoverageDamageToPropertyOfOthersValue) {
    CoverageDamageToPropertyOfOthersValue["Dollars500"] = "Dollars500";
})(CoverageDamageToPropertyOfOthersValue || (CoverageDamageToPropertyOfOthersValue = {}));
export var CoverageDebrisRemovalValue;
(function (CoverageDebrisRemovalValue) {
    CoverageDebrisRemovalValue["Dollars5K"] = "Dollars5K";
    CoverageDebrisRemovalValue["Dollars10K"] = "Dollars10K";
})(CoverageDebrisRemovalValue || (CoverageDebrisRemovalValue = {}));
export var CoverageELiabilityValue;
(function (CoverageELiabilityValue) {
    CoverageELiabilityValue["Dollars25K"] = "Dollars25K";
    CoverageELiabilityValue["Dollars50K"] = "Dollars50K";
    CoverageELiabilityValue["Dollars100K"] = "Dollars100K";
    CoverageELiabilityValue["Dollars300K"] = "Dollars300K";
    CoverageELiabilityValue["Dollars500K"] = "Dollars500K";
})(CoverageELiabilityValue || (CoverageELiabilityValue = {}));
export var CoverageEarthquakeValue;
(function (CoverageEarthquakeValue) {
    CoverageEarthquakeValue["Percent10"] = "Percent10";
    CoverageEarthquakeValue["Percent15"] = "Percent15";
    CoverageEarthquakeValue["Percent20"] = "Percent20";
})(CoverageEarthquakeValue || (CoverageEarthquakeValue = {}));
export var CoverageEquipmentBreakdownValue;
(function (CoverageEquipmentBreakdownValue) {
    CoverageEquipmentBreakdownValue["Dollars100K"] = "Dollars100K";
})(CoverageEquipmentBreakdownValue || (CoverageEquipmentBreakdownValue = {}));
export var CoverageFMedicalPaymentToOthersValue;
(function (CoverageFMedicalPaymentToOthersValue) {
    CoverageFMedicalPaymentToOthersValue["Dollars1K"] = "Dollars1K";
    CoverageFMedicalPaymentToOthersValue["Dollars2K"] = "Dollars2K";
    CoverageFMedicalPaymentToOthersValue["Dollars3K"] = "Dollars3K";
    CoverageFMedicalPaymentToOthersValue["Dollars4K"] = "Dollars4K";
    CoverageFMedicalPaymentToOthersValue["Dollars5K"] = "Dollars5K";
    CoverageFMedicalPaymentToOthersValue["Dollars500"] = "Dollars500";
})(CoverageFMedicalPaymentToOthersValue || (CoverageFMedicalPaymentToOthersValue = {}));
export var CoverageFungiWetOrDryRotOrBacteriaPropertyValue;
(function (CoverageFungiWetOrDryRotOrBacteriaPropertyValue) {
    CoverageFungiWetOrDryRotOrBacteriaPropertyValue["Dollars3K500"] = "Dollars3K500";
})(CoverageFungiWetOrDryRotOrBacteriaPropertyValue || (CoverageFungiWetOrDryRotOrBacteriaPropertyValue = {}));
export var CoverageGolfCartValue;
(function (CoverageGolfCartValue) {
    CoverageGolfCartValue["Five"] = "Five";
    CoverageGolfCartValue["Four"] = "Four";
    CoverageGolfCartValue["One"] = "One";
    CoverageGolfCartValue["Three"] = "Three";
    CoverageGolfCartValue["Two"] = "Two";
})(CoverageGolfCartValue || (CoverageGolfCartValue = {}));
export var CoverageIdentityFraudExpenseValue;
(function (CoverageIdentityFraudExpenseValue) {
    CoverageIdentityFraudExpenseValue["Dollars15K"] = "Dollars15K";
})(CoverageIdentityFraudExpenseValue || (CoverageIdentityFraudExpenseValue = {}));
export var CoverageInflationGuardValue;
(function (CoverageInflationGuardValue) {
    CoverageInflationGuardValue["Percent3"] = "Percent3";
})(CoverageInflationGuardValue || (CoverageInflationGuardValue = {}));
export var CoverageLossAssessmentValue;
(function (CoverageLossAssessmentValue) {
    CoverageLossAssessmentValue["Dollars1K"] = "Dollars1K";
    CoverageLossAssessmentValue["Dollars5K"] = "Dollars5K";
})(CoverageLossAssessmentValue || (CoverageLossAssessmentValue = {}));
export var CoverageWaterBackupAndSumpOverflowValue;
(function (CoverageWaterBackupAndSumpOverflowValue) {
    CoverageWaterBackupAndSumpOverflowValue["Dollars5K"] = "Dollars5K";
    CoverageWaterBackupAndSumpOverflowValue["Dollars10K"] = "Dollars10K";
    CoverageWaterBackupAndSumpOverflowValue["Dollars25K"] = "Dollars25K";
})(CoverageWaterBackupAndSumpOverflowValue || (CoverageWaterBackupAndSumpOverflowValue = {}));
export var CoverageWaterDamageValue;
(function (CoverageWaterDamageValue) {
    CoverageWaterDamageValue["FullCoverage"] = "FullCoverage";
    CoverageWaterDamageValue["Percent10"] = "Percent10";
    CoverageWaterDamageValue["Percent25"] = "Percent25";
    CoverageWaterDamageValue["Percent50"] = "Percent50";
})(CoverageWaterDamageValue || (CoverageWaterDamageValue = {}));
export var CoveredOptionName;
(function (CoveredOptionName) {
    CoveredOptionName["AircraftAndMotorVehiclesCollision"] = "AircraftAndMotorVehiclesCollision";
    CoveredOptionName["BadWeather"] = "BadWeather";
    CoveredOptionName["BurglaryTheftVandalism"] = "BurglaryTheftVandalism";
    CoveredOptionName["Earthquake"] = "Earthquake";
    CoveredOptionName["Electronics"] = "Electronics";
    CoveredOptionName["FireSmokeAndExplosion"] = "FireSmokeAndExplosion";
    CoveredOptionName["Flood"] = "Flood";
    CoveredOptionName["Lawsuits"] = "Lawsuits";
    CoveredOptionName["NeglectAndIntentionalLoss"] = "NeglectAndIntentionalLoss";
    CoveredOptionName["OrdinanceOrLaw"] = "OrdinanceOrLaw";
    CoveredOptionName["PowerFailure"] = "PowerFailure";
    CoveredOptionName["Precipitation"] = "Precipitation";
    CoveredOptionName["RiotCivilCommotion"] = "RiotCivilCommotion";
    CoveredOptionName["ToolsAndEquipment"] = "ToolsAndEquipment";
    CoveredOptionName["Valuables"] = "Valuables";
    CoveredOptionName["VandalismAndTheft"] = "VandalismAndTheft";
    CoveredOptionName["WarAndNuclearHazard"] = "WarAndNuclearHazard";
    CoveredOptionName["WaterDamage"] = "WaterDamage";
})(CoveredOptionName || (CoveredOptionName = {}));
export var EmailDeliverability;
(function (EmailDeliverability) {
    EmailDeliverability["Deliverable"] = "DELIVERABLE";
    EmailDeliverability["Risky"] = "RISKY";
    EmailDeliverability["Undeliverable"] = "UNDELIVERABLE";
    EmailDeliverability["Unknown"] = "UNKNOWN";
})(EmailDeliverability || (EmailDeliverability = {}));
export var FieldType;
(function (FieldType) {
    FieldType["Dropdown"] = "Dropdown";
    FieldType["Slider"] = "Slider";
    FieldType["Toggle"] = "Toggle";
})(FieldType || (FieldType = {}));
export var HomeFixtures;
(function (HomeFixtures) {
    HomeFixtures["AFewExtras"] = "AFewExtras";
    HomeFixtures["Standard"] = "Standard";
    HomeFixtures["TopOfTheLine"] = "TopOfTheLine";
})(HomeFixtures || (HomeFixtures = {}));
export var HomeType;
(function (HomeType) {
    HomeType["AccessoryDwellingUnit"] = "AccessoryDwellingUnit";
    HomeType["CrossMod"] = "CrossMod";
    HomeType["DoubleWide"] = "DoubleWide";
    HomeType["Duplex"] = "Duplex";
    HomeType["Modular"] = "Modular";
    HomeType["ParkModel"] = "ParkModel";
    HomeType["SelfStorageSecured"] = "SelfStorageSecured";
    HomeType["SelfStorageUnSecured"] = "SelfStorageUnSecured";
    HomeType["SingleWide"] = "SingleWide";
    HomeType["StationaryTravelTrailer"] = "StationaryTravelTrailer";
    HomeType["TinyHome"] = "TinyHome";
    HomeType["TripleWide"] = "TripleWide";
    HomeType["Unknown"] = "Unknown";
})(HomeType || (HomeType = {}));
export var IbhsFortifiedCertification;
(function (IbhsFortifiedCertification) {
    IbhsFortifiedCertification["Bronze"] = "Bronze";
    IbhsFortifiedCertification["Gold"] = "Gold";
    IbhsFortifiedCertification["No"] = "No";
    IbhsFortifiedCertification["SaferLiving"] = "SaferLiving";
    IbhsFortifiedCertification["Silver"] = "Silver";
})(IbhsFortifiedCertification || (IbhsFortifiedCertification = {}));
export var OccupationType;
(function (OccupationType) {
    OccupationType["Accountant"] = "Accountant";
    OccupationType["ArtistDesigner"] = "ArtistDesigner";
    OccupationType["BusinessOwner"] = "BusinessOwner";
    OccupationType["ConstructionWorker"] = "ConstructionWorker";
    OccupationType["CustomerService"] = "CustomerService";
    OccupationType["DoctorNurse"] = "DoctorNurse";
    OccupationType["Driver"] = "Driver";
    OccupationType["EducatorTeacher"] = "EducatorTeacher";
    OccupationType["Engineer"] = "Engineer";
    OccupationType["ExecutiveManager"] = "ExecutiveManager";
    OccupationType["FinancialAnalyst"] = "FinancialAnalyst";
    OccupationType["HealthcareWorker"] = "HealthcareWorker";
    OccupationType["ItSoftwareProfessional"] = "ITSoftwareProfessional";
    OccupationType["Lawyer"] = "Lawyer";
    OccupationType["MarketingSales"] = "MarketingSales";
    OccupationType["MechanicTechnician"] = "MechanicTechnician";
    OccupationType["Military"] = "Military";
    OccupationType["PoliceFirefighter"] = "PoliceFirefighter";
    OccupationType["RealEstateAgent"] = "RealEstateAgent";
    OccupationType["RetailWorker"] = "RetailWorker";
    OccupationType["ScientistResearcher"] = "ScientistResearcher";
    OccupationType["Student"] = "Student";
    OccupationType["Unemployed"] = "Unemployed";
    OccupationType["WriterEditor"] = "WriterEditor";
})(OccupationType || (OccupationType = {}));
export var Operator;
(function (Operator) {
    Operator["Equal"] = "Equal";
    Operator["LessThanOrEqual"] = "LessThanOrEqual";
    Operator["MoreThanOrEqual"] = "MoreThanOrEqual";
})(Operator || (Operator = {}));
export var OrganizationRelationshipType;
(function (OrganizationRelationshipType) {
    OrganizationRelationshipType["Officer"] = "Officer";
    OrganizationRelationshipType["Other"] = "Other";
    OrganizationRelationshipType["Owner"] = "Owner";
    OrganizationRelationshipType["Partner"] = "Partner";
    OrganizationRelationshipType["Trustee"] = "Trustee";
})(OrganizationRelationshipType || (OrganizationRelationshipType = {}));
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType["Corporation"] = "Corporation";
    OrganizationType["Estate"] = "Estate";
    OrganizationType["Llc"] = "LLC";
    OrganizationType["Llp"] = "LLP";
    OrganizationType["NotListed"] = "NotListed";
    OrganizationType["Partnership"] = "Partnership";
    OrganizationType["Trust"] = "Trust";
})(OrganizationType || (OrganizationType = {}));
export var ParameterName;
(function (ParameterName) {
    ParameterName["CommunityName"] = "CommunityName";
    ParameterName["Manufacturer"] = "Manufacturer";
})(ParameterName || (ParameterName = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["BankAccount"] = "BankAccount";
    PaymentMethod["CreditDebitCard"] = "CreditDebitCard";
    PaymentMethod["MortgageBill"] = "MortgageBill";
})(PaymentMethod || (PaymentMethod = {}));
export var PaymentSchedule;
(function (PaymentSchedule) {
    PaymentSchedule["ElevenPay"] = "ElevenPay";
    PaymentSchedule["FullPay"] = "FullPay";
    PaymentSchedule["MortgageBill"] = "MortgageBill";
    PaymentSchedule["TwoPay"] = "TwoPay";
})(PaymentSchedule || (PaymentSchedule = {}));
export var PersonalPropertyType;
(function (PersonalPropertyType) {
    PersonalPropertyType["AllOther"] = "AllOther";
    PersonalPropertyType["Bikes"] = "Bikes";
    PersonalPropertyType["CameraRecorderMedia"] = "CameraRecorderMedia";
    PersonalPropertyType["ComputerEquipment"] = "ComputerEquipment";
    PersonalPropertyType["FineArts"] = "FineArts";
    PersonalPropertyType["Furs"] = "Furs";
    PersonalPropertyType["GolfersEquipment"] = "GolfersEquipment";
    PersonalPropertyType["GunsAndAmmunition"] = "GunsAndAmmunition";
    PersonalPropertyType["Jewelry"] = "Jewelry";
    PersonalPropertyType["MusicalInstruments"] = "MusicalInstruments";
    PersonalPropertyType["RareAndCurrentCoins"] = "RareAndCurrentCoins";
    PersonalPropertyType["Silverware"] = "Silverware";
    PersonalPropertyType["StampsBooks"] = "StampsBooks";
    PersonalPropertyType["Tools"] = "Tools";
})(PersonalPropertyType || (PersonalPropertyType = {}));
export var PolicyPlan;
(function (PolicyPlan) {
    PolicyPlan["CoverTree"] = "CoverTree";
    PolicyPlan["Gold"] = "Gold";
    PolicyPlan["Platinum"] = "Platinum";
    PolicyPlan["Silver"] = "Silver";
})(PolicyPlan || (PolicyPlan = {}));
export var PolicyStatus;
(function (PolicyStatus) {
    PolicyStatus["Activated"] = "Activated";
    PolicyStatus["Cancelled"] = "Cancelled";
    PolicyStatus["Expired"] = "Expired";
    PolicyStatus["InitialQuote"] = "InitialQuote";
    PolicyStatus["PendingCancellation"] = "PendingCancellation";
    PolicyStatus["PendingCancellationEsignRequired"] = "PendingCancellationEsignRequired";
    PolicyStatus["PendingCancellationInspection"] = "PendingCancellationInspection";
    PolicyStatus["PendingCancellationNonPay"] = "PendingCancellationNonPay";
    PolicyStatus["PendingCancellationOther"] = "PendingCancellationOther";
    PolicyStatus["PendingEsignRequired"] = "PendingEsignRequired";
})(PolicyStatus || (PolicyStatus = {}));
export var PolicyStep;
(function (PolicyStep) {
    PolicyStep["Checkout"] = "Checkout";
    PolicyStep["ClaimsCheck"] = "ClaimsCheck";
    PolicyStep["ExtraCoverages"] = "ExtraCoverages";
    PolicyStep["HomeDetails"] = "HomeDetails";
    PolicyStep["HomeOptions"] = "HomeOptions";
    PolicyStep["PersonalDetails"] = "PersonalDetails";
    PolicyStep["PersonalizedPlans"] = "PersonalizedPlans";
    PolicyStep["PolicyDetails"] = "PolicyDetails";
    PolicyStep["PolicySummary"] = "PolicySummary";
    PolicyStep["UnderwritingQuestions"] = "UnderwritingQuestions";
})(PolicyStep || (PolicyStep = {}));
export var PolicyUsage;
(function (PolicyUsage) {
    PolicyUsage["Owner"] = "Owner";
    PolicyUsage["Rental"] = "Rental";
    PolicyUsage["Seasonal"] = "Seasonal";
    PolicyUsage["Tenant"] = "Tenant";
    PolicyUsage["Vacant"] = "Vacant";
})(PolicyUsage || (PolicyUsage = {}));
export var PolicyholderType;
(function (PolicyholderType) {
    PolicyholderType["Organization"] = "Organization";
    PolicyholderType["Person"] = "Person";
})(PolicyholderType || (PolicyholderType = {}));
export var PriorCarrierName;
(function (PriorCarrierName) {
    PriorCarrierName["Aegis"] = "Aegis";
    PriorCarrierName["Allstate"] = "Allstate";
    PriorCarrierName["AmericanBankers"] = "AmericanBankers";
    PriorCarrierName["AmericanModern"] = "AmericanModern";
    PriorCarrierName["AmericanReliable"] = "AmericanReliable";
    PriorCarrierName["AmericanSummit"] = "AmericanSummit";
    PriorCarrierName["Assurant"] = "Assurant";
    PriorCarrierName["Bankers"] = "Bankers";
    PriorCarrierName["Foremost"] = "Foremost";
    PriorCarrierName["Homesite"] = "Homesite";
    PriorCarrierName["Kin"] = "Kin";
    PriorCarrierName["LibertyMutual"] = "LibertyMutual";
    PriorCarrierName["Markel"] = "Markel";
    PriorCarrierName["NationalLloyds"] = "NationalLloyds";
    PriorCarrierName["NationalSecurity"] = "NationalSecurity";
    PriorCarrierName["NotListed"] = "NotListed";
    PriorCarrierName["PacificSpecialty"] = "PacificSpecialty";
    PriorCarrierName["Progressive"] = "Progressive";
    PriorCarrierName["Shelter"] = "Shelter";
    PriorCarrierName["StateFarm"] = "StateFarm";
    PriorCarrierName["TowerHill"] = "TowerHill";
    PriorCarrierName["Usaa"] = "USAA";
})(PriorCarrierName || (PriorCarrierName = {}));
export var PriorClaimCategory;
(function (PriorClaimCategory) {
    PriorClaimCategory["CollisionVehicleAircraft"] = "CollisionVehicleAircraft";
    PriorClaimCategory["Earthquake"] = "Earthquake";
    PriorClaimCategory["FireSmoke"] = "FireSmoke";
    PriorClaimCategory["Flood"] = "Flood";
    PriorClaimCategory["InteriorWater"] = "InteriorWater";
    PriorClaimCategory["Liability"] = "Liability";
    PriorClaimCategory["MedicalPayments"] = "MedicalPayments";
    PriorClaimCategory["Other"] = "Other";
    PriorClaimCategory["TheftBurglary"] = "TheftBurglary";
    PriorClaimCategory["VandalismOrMaliciousMischief"] = "VandalismOrMaliciousMischief";
    PriorClaimCategory["WeatherHail"] = "WeatherHail";
    PriorClaimCategory["WeatherLightning"] = "WeatherLightning";
    PriorClaimCategory["WeatherWater"] = "WeatherWater";
    PriorClaimCategory["WeatherWind"] = "WeatherWind";
})(PriorClaimCategory || (PriorClaimCategory = {}));
export var PriorClaimSource;
(function (PriorClaimSource) {
    PriorClaimSource["Internal"] = "Internal";
    PriorClaimSource["ThirdParty"] = "ThirdParty";
    PriorClaimSource["UserDeclared"] = "UserDeclared";
})(PriorClaimSource || (PriorClaimSource = {}));
export var PriorClaimsQuestionsFieldName;
(function (PriorClaimsQuestionsFieldName) {
    PriorClaimsQuestionsFieldName["Amount"] = "amount";
    PriorClaimsQuestionsFieldName["Catastrophe"] = "catastrophe";
    PriorClaimsQuestionsFieldName["Category"] = "category";
    PriorClaimsQuestionsFieldName["Date"] = "date";
})(PriorClaimsQuestionsFieldName || (PriorClaimsQuestionsFieldName = {}));
export var PriorInsurance;
(function (PriorInsurance) {
    PriorInsurance["BuyingNewHome"] = "BuyingNewHome";
    PriorInsurance["NoInsurance"] = "NoInsurance";
    PriorInsurance["RentingNewHome"] = "RentingNewHome";
    PriorInsurance["SwitchingCarriers"] = "SwitchingCarriers";
})(PriorInsurance || (PriorInsurance = {}));
export var PriorPolicyExpirationDate;
(function (PriorPolicyExpirationDate) {
    PriorPolicyExpirationDate["Between1_7"] = "Between1_7";
    PriorPolicyExpirationDate["Between8_30"] = "Between8_30";
    PriorPolicyExpirationDate["Between31_90"] = "Between31_90";
    PriorPolicyExpirationDate["MoreThan90"] = "MoreThan90";
    PriorPolicyExpirationDate["NeverBeenInsured"] = "NeverBeenInsured";
})(PriorPolicyExpirationDate || (PriorPolicyExpirationDate = {}));
export var ProductTypeName;
(function (ProductTypeName) {
    ProductTypeName["FullRepair"] = "FullRepair";
    ProductTypeName["MhHomeowners"] = "MHHomeowners";
})(ProductTypeName || (ProductTypeName = {}));
export var PurchaseDate;
(function (PurchaseDate) {
    PurchaseDate["Between1_7"] = "Between1_7";
    PurchaseDate["Between8_30"] = "Between8_30";
    PurchaseDate["Between31_90"] = "Between31_90";
    PurchaseDate["CurrentlyInTheBuyingProcess"] = "CurrentlyInTheBuyingProcess";
    PurchaseDate["MoreThan90"] = "MoreThan90";
})(PurchaseDate || (PurchaseDate = {}));
export var QuestionType;
(function (QuestionType) {
    QuestionType["Amount"] = "Amount";
    QuestionType["Checkbox"] = "Checkbox";
    QuestionType["Date"] = "Date";
    QuestionType["Dropdown"] = "Dropdown";
})(QuestionType || (QuestionType = {}));
export var Relationship;
(function (Relationship) {
    Relationship["Friend"] = "Friend";
    Relationship["Officer"] = "Officer";
    Relationship["Other"] = "Other";
    Relationship["OtherFamily"] = "OtherFamily";
    Relationship["Owner"] = "Owner";
    Relationship["Partner"] = "Partner";
    Relationship["Spouse"] = "Spouse";
    Relationship["Trustee"] = "Trustee";
})(Relationship || (Relationship = {}));
export var RenewalStatus;
(function (RenewalStatus) {
    RenewalStatus["Discarded"] = "Discarded";
    RenewalStatus["Issued"] = "Issued";
    RenewalStatus["NonRenewalIssued"] = "NonRenewalIssued";
    RenewalStatus["NotApplicable"] = "NotApplicable";
    RenewalStatus["OfferSent"] = "OfferSent";
    RenewalStatus["OfferSentFailed"] = "OfferSentFailed";
    RenewalStatus["PaymentFailed"] = "PaymentFailed";
    RenewalStatus["PricingFailed"] = "PricingFailed";
    RenewalStatus["UwAccepted"] = "UWAccepted";
    RenewalStatus["UwFailed"] = "UWFailed";
    RenewalStatus["UwReview"] = "UWReview";
    RenewalStatus["Upcoming"] = "Upcoming";
})(RenewalStatus || (RenewalStatus = {}));
export var ResidenceBurglaryValue;
(function (ResidenceBurglaryValue) {
    ResidenceBurglaryValue["Dollars5K"] = "Dollars5K";
    ResidenceBurglaryValue["Dollars10K"] = "Dollars10K";
    ResidenceBurglaryValue["Dollars15K"] = "Dollars15K";
    ResidenceBurglaryValue["Dollars20K"] = "Dollars20K";
    ResidenceBurglaryValue["Dollars30K"] = "Dollars30K";
    ResidenceBurglaryValue["Dollars40K"] = "Dollars40K";
    ResidenceBurglaryValue["Dollars50K"] = "Dollars50K";
})(ResidenceBurglaryValue || (ResidenceBurglaryValue = {}));
export var RoofCondition;
(function (RoofCondition) {
    RoofCondition["Excellent"] = "Excellent";
    RoofCondition["Fair"] = "Fair";
    RoofCondition["Good"] = "Good";
    RoofCondition["Poor"] = "Poor";
    RoofCondition["Severe"] = "Severe";
    RoofCondition["Unknown"] = "Unknown";
})(RoofCondition || (RoofCondition = {}));
export var RoofShape;
(function (RoofShape) {
    RoofShape["BowedCurvedArched"] = "BowedCurvedArched";
    RoofShape["Flat"] = "Flat";
    RoofShape["Gable"] = "Gable";
    RoofShape["Hip"] = "Hip";
    RoofShape["NotListed"] = "NotListed";
    RoofShape["Shed"] = "Shed";
})(RoofShape || (RoofShape = {}));
export var SettlementOption;
(function (SettlementOption) {
    SettlementOption["ActualCashValue"] = "ActualCashValue";
    SettlementOption["ExtendedReplacementCost"] = "ExtendedReplacementCost";
    SettlementOption["FullRepairCost"] = "FullRepairCost";
    SettlementOption["ReplacementCost"] = "ReplacementCost";
})(SettlementOption || (SettlementOption = {}));
export var SkirtingType;
(function (SkirtingType) {
    SkirtingType["Lattice"] = "Lattice";
    SkirtingType["MasonryBrick"] = "MasonryBrick";
    SkirtingType["Metal"] = "Metal";
    SkirtingType["NotFullyEnclosed"] = "NotFullyEnclosed";
    SkirtingType["NotListed"] = "NotListed";
    SkirtingType["Vinyl"] = "Vinyl";
})(SkirtingType || (SkirtingType = {}));
export var TypeOfFuelValue;
(function (TypeOfFuelValue) {
    TypeOfFuelValue["Coal"] = "Coal";
    TypeOfFuelValue["Electric"] = "Electric";
    TypeOfFuelValue["Kerosene"] = "Kerosene";
    TypeOfFuelValue["NotListed"] = "NotListed";
    TypeOfFuelValue["Solar"] = "Solar";
    TypeOfFuelValue["Wood"] = "Wood";
})(TypeOfFuelValue || (TypeOfFuelValue = {}));
export var UnderwritingDecision;
(function (UnderwritingDecision) {
    UnderwritingDecision["Accept"] = "accept";
    UnderwritingDecision["None"] = "none";
    UnderwritingDecision["Reject"] = "reject";
})(UnderwritingDecision || (UnderwritingDecision = {}));
export var UnitLocation;
(function (UnitLocation) {
    UnitLocation["LargeManufacturedHome"] = "LargeManufacturedHome";
    UnitLocation["OnMyOwnLand"] = "OnMyOwnLand";
    UnitLocation["SmallManufacturedHome"] = "SmallManufacturedHome";
    UnitLocation["Unknown"] = "Unknown";
})(UnitLocation || (UnitLocation = {}));
export var VacancyReason;
(function (VacancyReason) {
    VacancyReason["BetweenTenants"] = "BetweenTenants";
    VacancyReason["Condemned"] = "Condemned";
    VacancyReason["ForSale"] = "ForSale";
    VacancyReason["Other"] = "Other";
    VacancyReason["UnderRenovation"] = "UnderRenovation";
})(VacancyReason || (VacancyReason = {}));
export var VisitorsInAMonthValue;
(function (VisitorsInAMonthValue) {
    VisitorsInAMonthValue["Five"] = "Five";
    VisitorsInAMonthValue["Four"] = "Four";
    VisitorsInAMonthValue["One"] = "One";
    VisitorsInAMonthValue["SixOrMore"] = "SixOrMore";
    VisitorsInAMonthValue["Three"] = "Three";
    VisitorsInAMonthValue["Two"] = "Two";
    VisitorsInAMonthValue["Zero"] = "Zero";
})(VisitorsInAMonthValue || (VisitorsInAMonthValue = {}));
export var WaterDamageDeductible;
(function (WaterDamageDeductible) {
    WaterDamageDeductible["Dollars2K500"] = "Dollars2K500";
    WaterDamageDeductible["Dollars5K"] = "Dollars5K";
    WaterDamageDeductible["Dollars10K"] = "Dollars10K";
})(WaterDamageDeductible || (WaterDamageDeductible = {}));
export var WindHailDeductible;
(function (WindHailDeductible) {
    WindHailDeductible["Dollars1K"] = "Dollars1K";
    WindHailDeductible["Dollars2K500"] = "Dollars2K500";
    WindHailDeductible["Dollars5K"] = "Dollars5K";
    WindHailDeductible["Dollars10K"] = "Dollars10K";
    WindHailDeductible["Dollars500"] = "Dollars500";
})(WindHailDeductible || (WindHailDeductible = {}));
export const NewBusinessPolicyCommonDetailsFragmentFragmentDoc = gql `
  fragment NewBusinessPolicyCommonDetailsFragment on Policy {
    policyLocator
    selectedQuoteLocator
    startDate
    endDate
    step
  }
`;
export const AddressFragmentFragmentDoc = gql `
  fragment AddressFragment on Address {
    streetAddress
    city
    zipCode
    state
    unitNumber
    county
    countryCode
  }
`;
export const PolicyholderFragmentFragmentDoc = gql `
  fragment PolicyholderFragment on Policyholder {
    describeOrgType
    emailAddress
    firstName
    lastName
    mailingAddress {
      ...AddressFragment
    }
    type
    secondaryContactNumber
    occupationType
    numberOfVehicles
    middleName
    orgName
    orgType
    policyholderLocator
    primaryContactNumber
    repRelationToOrg
  }
  ${AddressFragmentFragmentDoc}
`;
export const DocumentFragmentFragmentDoc = gql `
  fragment DocumentFragment on PolicyDocument {
    urlExpirationTimestamp
    url
    type
    policyModificationLocator
    fileName
    documentLocator
    displayName
    createdTimestamp
  }
`;
export const PolicyLevelCoveragesFragmentFragmentDoc = gql `
  fragment PolicyLevelCoveragesFragment on Policy {
    policyLevelCoverages {
      scheduledPersonalProperty {
        valueIsCustomizable
        valueIsHidden
        value {
          description
          fieldGroupLocator
          type
          value
        }
      }
      identityFraudExpense {
        defaultValue
        value
        valueIsCustomizable
        valueIsHidden
      }
    }
  }
`;
export const BasicUnitDetailsFragmentFragmentDoc = gql `
  fragment BasicUnitDetailsFragment on PolicyUnit {
    unitId
    exposureLocator
  }
`;
export const CoverageBooleanFragmentFragmentDoc = gql `
  fragment CoverageBooleanFragment on CoverageBoolean {
    defaultValue
    value
    valueIsHidden
    valueIsCustomizable
  }
`;
export const BasicUnitDetailsWithUnitLevelCoveragesFragmentFragmentDoc = gql `
  fragment BasicUnitDetailsWithUnitLevelCoveragesFragment on PolicyUnit {
    ...BasicUnitDetailsFragment
    unitLevelCoverages {
      buildersRisk {
        ...CoverageBooleanFragment
      }
      debrisRemoval {
        defaultValue
        value
        valueCustomization {
          options {
            label
            value
          }
        }
        valueIsHidden
        valueIsCustomizable
      }
      divingBoardSlideLiabilityExtension {
        ...CoverageBooleanFragment
      }
      earthquake {
        defaultValue
        value
        valueCustomization {
          options
        }
        valueIsHidden
        valueIsCustomizable
      }
      enhancedCoverage {
        ...CoverageBooleanFragment
      }
      equipmentBreakdown {
        defaultValue
        value
        valueIsCustomizable
        valueIsHidden
      }
      fortifiedRoofUpgrade {
        ...CoverageBooleanFragment
      }
      incidentalFarming {
        ...CoverageBooleanFragment
      }
      inflationGuard {
        value
        valueCustomization {
          options
        }
        valueIsHidden
        valueIsCustomizable
      }
      lossAssessment {
        defaultValue
        value
        valueCustomization {
          options {
            label
            value
          }
        }
        valueIsHidden
        valueIsCustomizable
      }
      mineSubsidence {
        ...CoverageBooleanFragment
      }
      mineSubsidenceScheduled {
        valueIsCustomizable
        valueIsHidden
        value {
          description
          locator
          value
        }
      }
      golfCarts {
        defaultValue
        value
        valueCustomization {
          options
        }
        valueIsHidden
        valueIsCustomizable
      }
      vacationRental {
        ...CoverageBooleanFragment
      }
      residenceBurglary {
        defaultValue
        value
        valueCustomization {
          constraint {
            dependsOn
            operator
          }
          options {
            label
            value
          }
        }
        valueIsHidden
        valueIsCustomizable
      }
      roofPaymentSchedule {
        ...CoverageBooleanFragment
      }
      secondaryResidenceLiability {
        value {
          fieldGroupLocator
          address
        }
        valueIsHidden
        valueIsCustomizable
      }
      sinkhole {
        ...CoverageBooleanFragment
      }
      trampolineLiabilityExtension {
        ...CoverageBooleanFragment
      }
      tripCollision {
        ...CoverageBooleanFragment
      }
      vandalismOrMaliciousMischief {
        ...CoverageBooleanFragment
      }
      waterBackupAndSumpOverflow {
        defaultValue
        value
        valueCustomization {
          options {
            label
            value
          }
        }
        valueIsHidden
        valueIsCustomizable
      }
      windstormOrHailExclusion {
        defaultValue
        value
        valueIsHidden
        valueIsCustomizable
      }
      coverageA {
        settlementOptionCustomization {
          options
        }
        settlementOption
        settlementOptionIsCustomizable
        settlementOptionIsHidden
        value
        valueCustomization {
          constraint {
            dependsOn
            operator
          }
          max
          min
          step
        }
        valueIsHidden
        valueIsCustomizable
      }
      coverageB {
        defaultSettlementOption
        settlementOption
        settlementOptionCustomization {
          options
        }
        settlementOptionIsCustomizable
        settlementOptionIsHidden
        value
        valueCustomization {
          constraint {
            dependsOn
            operator
          }
          max
          min
          step
        }
        valueIsCustomizable
        valueIsHidden
      }
      coverageC {
        defaultSettlementOption
        settlementOption
        settlementOptionCustomization {
          options
        }
        settlementOptionIsCustomizable
        settlementOptionIsHidden
        value
        valueCustomization {
          constraint {
            dependsOn
            operator
          }
          max
          min
          step
        }
        valueIsCustomizable
        valueIsHidden
      }
      coverageDLossOfUse {
        value
        valueCustomization {
          options
        }
        valueIsCustomizable
        valueIsHidden
      }
      coverageEPersonalLiability {
        value
        valueCustomization {
          constraint {
            dependsOn
            operator
          }
          options
        }
        valueIsCustomizable
        valueIsHidden
      }
      coverageEPremisesLiability {
        value
        valueCustomization {
          constraint {
            dependsOn
            operator
          }
          options
        }
        valueIsCustomizable
        valueIsHidden
      }
      coverageFMedicalPaymentToOthers {
        value
        valueCustomization {
          options {
            label
            value
          }
        }
        valueIsCustomizable
        valueIsHidden
      }
      deductibles {
        allOtherPerilsDeductible
        allOtherPerilsDeductibleCustomization {
          constraint {
            dependsOn
            operator
          }
          options
        }
        allOtherPerilsDeductibleIsCustomizable
        allOtherPerilsDeductibleIsHidden
        waterDamageDeductible
        waterDamageDeductibleCustomization {
          options
        }
        waterDamageDeductibleIsCustomizable
        waterDamageDeductibleIsHidden
        windHailDeductible
        windHailDeductibleCustomization {
          constraint {
            dependsOn
            operator
          }
          options
        }
        windHailDeductibleIsCustomizable
        windHailDeductibleIsHidden
      }
      waterDamage {
        value
        valueCustomization {
          options
        }
        valueIsCustomizable
        valueIsHidden
      }
      animalLiability {
        value
        valueCustomization {
          options {
            label
            value
          }
        }
        valueIsCustomizable
        valueIsHidden
      }
      fungiWetOrDryRotOrBacteriaProperty {
        value
        valueCustomization {
          options
        }
        valueIsHidden
        valueIsCustomizable
      }
      damageToPropertyOfOthers {
        value
        valueCustomization {
          constraint {
            dependsOn
            operator
          }
          options
        }
        valueIsCustomizable
        valueIsHidden
      }
    }
  }
  ${BasicUnitDetailsFragmentFragmentDoc}
  ${CoverageBooleanFragmentFragmentDoc}
`;
export const UnitDetailsFragmentFragmentDoc = gql `
  fragment UnitDetailsFragment on PolicyUnit {
    address {
      ...AddressFragment
    }
    construction {
      homeType
      manufacturerName
      makeCustom
      modelHome
      homeFixtures
      roofShape
      roofYearYyyy
      roofCondition
      totalSquareFootage
      homeWidth
      homeLength
      modelYear
      homeHudNumber
      skirtingType
    }
    ...BasicUnitDetailsWithUnitLevelCoveragesFragment
    details {
      unitLocation
      purchaseDate
      communityName
      latitude
      longitude
      formattedLocationAddress
    }
    coverageDetails {
      covered
      notCovered
    }
    selectedPlan
    unitLevelUnderwritingQuestions {
      fieldName
      default
      options
    }
    unitLevelUnderwritingAnswers {
      animalBite {
        isHidden
        value
      }
      automaticSprinkler {
        isHidden
        value
      }
      burglarAlarm {
        isHidden
        value
      }
      business {
        businessDescription {
          isHidden
          value
        }
        businessEmployeesOnPremises {
          isHidden
          value
        }
        businessOnPremises {
          value
          isHidden
        }
        daycareOnPremises {
          isHidden
          value
        }
        visitorsInAMonth {
          isHidden
          value
        }
      }
      mortgage {
        isHidden
        value
      }
      propertyWithFireProtection {
        isHidden
        value
      }
      stormMitigationFortified {
        isHidden
        value
      }
      stormMitigationImpactglass {
        isHidden
        value
      }
      stormMitigationShutters {
        isHidden
        value
      }
      secureRails {
        isHidden
        value
      }
      supplementalHeating {
        pleaseDescribe {
          isHidden
          value
        }
        sourceOfHeat {
          value
          isHidden
        }
        sourceOfHeatInstallation {
          isHidden
          value
        }
        typeOfFuel {
          isHidden
          value
        }
      }
      thermoStaticControl {
        isHidden
        value
      }
      swimmingPool {
        divingBoard {
          isHidden
          value
        }
        divingBoardSlideLiabilityExtension {
          isHidden
          value
        }
        fourFeetFence {
          isHidden
          value
        }
        swimmingPool {
          isHidden
          value
        }
      }
      trampoline {
        trampolineLiability {
          isHidden
          value
        }
        trampolineLiabilityExtension {
          isHidden
          value
        }
        trampolineSafetyNet {
          isHidden
          value
        }
      }
      unitIsTied {
        isHidden
        value
      }
      unrepairedDamages {
        isHidden
        value
      }
      utilityServices {
        isHidden
        value
      }
      wroughtIron {
        isHidden
        value
      }
    }
    usage
    vacancyReason
    valuationReportUrl
  }
  ${AddressFragmentFragmentDoc}
  ${BasicUnitDetailsWithUnitLevelCoveragesFragmentFragmentDoc}
`;
export const PricingFragmentFragmentDoc = gql `
  fragment PricingFragment on UnitPricing {
    commissions {
      amount
      recipient
    }
    fees {
      name
      amount
    }
    grossTaxes
    grossFees
    grossPremium
    totalDue
  }
`;
export const PolicyOffersFragmentFragmentDoc = gql `
  fragment PolicyOffersFragment on Policy {
    offers {
      quoteLocator
      plan
      pricing {
        ...PricingFragment
      }
      quote {
        homeCoverage
        lossOfUse
        medicalPaymentToOther
        otherStructures
        personalLiability
        premisesLiability
        standardDeductible
        windHailDeductible
        yourBelongings
        waterDamageDeductible
        waterDamage
        roofPaymentSchedule
      }
      homeCoverageDescription
      yourBelongingsDescription
    }
  }
  ${PricingFragmentFragmentDoc}
`;
export const NewBusinessPolicyCreatedFragmentFragmentDoc = gql `
  fragment NewBusinessPolicyCreatedFragment on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    policyholder {
      ...PolicyholderFragment
    }
    productTypeName
    mainUnitType
    previousAddress {
      ...AddressFragment
    }
    additionalInsured {
      adFirstName
      adLastName
      locator
      relationshipIndividual
    }
    gotInsuranceScoreHit
    bookConversion {
      source
      previousPolicyId
    }
    priorInsuranceDetails {
      priorInsurance
      priorCarrierName
      priorPolicyExpirationDate
    }
    insuredDateOfBirth
    isEsigned
    isAgentsSignResponsibility
    isInternalAgency
    physicallyMailDocuments
    hasAnotherCoverTreePolicy
    hasAutoPolicy
    documents {
      ...DocumentFragment
    }
    ...PolicyLevelCoveragesFragment
    policyLevelUnderwritingAnswers {
      animalBite
      conviction
      cancellationRenew {
        cancellationRenew
        reasonCancellationRenew
      }
    }
    policyLevelUnderwritingQuestions {
      fieldName
      default
      options
    }
    units {
      ...UnitDetailsFragment
    }
    ...PolicyOffersFragment
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${PolicyholderFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${DocumentFragmentFragmentDoc}
  ${PolicyLevelCoveragesFragmentFragmentDoc}
  ${UnitDetailsFragmentFragmentDoc}
  ${PolicyOffersFragmentFragmentDoc}
`;
export const BasicUnitDetailsWithUwQuestionsFragmentFragmentDoc = gql `
  fragment BasicUnitDetailsWithUWQuestionsFragment on PolicyUnit {
    ...BasicUnitDetailsFragment
    unitLevelUnderwritingAnswers {
      animalBite {
        value
        isHidden
      }
      automaticSprinkler {
        value
        isHidden
      }
      burglarAlarm {
        value
        isHidden
      }
      business {
        businessOnPremises {
          value
          isHidden
        }
        daycareOnPremises {
          value
          isHidden
        }
        businessDescription {
          value
          isHidden
        }
        businessEmployeesOnPremises {
          value
          isHidden
        }
        visitorsInAMonth {
          value
          isHidden
        }
      }
      supplementalHeating {
        sourceOfHeat {
          value
          isHidden
        }
        sourceOfHeatInstallation {
          value
          isHidden
        }
        typeOfFuel {
          value
          isHidden
        }
        pleaseDescribe {
          value
          isHidden
        }
      }
      swimmingPool {
        swimmingPool {
          value
          isHidden
        }
        fourFeetFence {
          value
          isHidden
        }
        divingBoard {
          value
          isHidden
        }
        divingBoardSlideLiabilityExtension {
          value
          isHidden
        }
      }
      mortgage {
        value
        isHidden
      }
      propertyWithFireProtection {
        value
        isHidden
      }
      stormMitigationFortified {
        isHidden
        value
      }
      stormMitigationImpactglass {
        isHidden
        value
      }
      stormMitigationShutters {
        isHidden
        value
      }
      secureRails {
        value
        isHidden
      }
      thermoStaticControl {
        value
        isHidden
      }
      trampoline {
        trampolineLiability {
          value
          isHidden
        }
        trampolineSafetyNet {
          value
          isHidden
        }
        trampolineLiabilityExtension {
          value
          isHidden
        }
      }
      unitIsTied {
        value
        isHidden
      }
      unrepairedDamages {
        value
        isHidden
      }
      utilityServices {
        value
        isHidden
      }
      wroughtIron {
        value
        isHidden
      }
    }
    unitLevelUnderwritingQuestions {
      fieldName
      default
      options
    }
    ...BasicUnitDetailsWithUnitLevelCoveragesFragment
  }
  ${BasicUnitDetailsFragmentFragmentDoc}
  ${BasicUnitDetailsWithUnitLevelCoveragesFragmentFragmentDoc}
`;
export const NewBusinessPolicyWithUwQuestionsFragmentDoc = gql `
  fragment NewBusinessPolicyWithUWQuestions on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    policyLevelUnderwritingAnswers {
      animalBite
      conviction
      cancellationRenew {
        cancellationRenew
        reasonCancellationRenew
      }
    }
    units {
      ...BasicUnitDetailsWithUWQuestionsFragment
    }
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${BasicUnitDetailsWithUwQuestionsFragmentFragmentDoc}
`;
export const NewBusinessPolicyWithPriorClaimsFragmentFragmentDoc = gql `
  fragment NewBusinessPolicyWithPriorClaimsFragment on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    previousAddress {
      ...AddressFragment
    }
    priorClaims {
      fieldGroupLocator
      amount
      subjects {
        firstName
        lastName
      }
      source
      category
      date
      catastrophe
    }
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
`;
export const NewBusinessPolicyAfterQuoteSelectionFragmentFragmentDoc = gql `
  fragment NewBusinessPolicyAfterQuoteSelectionFragment on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    policyLevelUnderwritingAnswers {
      animalBite
      conviction
      cancellationRenew {
        cancellationRenew
        reasonCancellationRenew
      }
    }
    ...PolicyLevelCoveragesFragment
    units {
      ...BasicUnitDetailsWithUWQuestionsFragment
      ...BasicUnitDetailsWithUnitLevelCoveragesFragment
      selectedPlan
    }
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${PolicyLevelCoveragesFragmentFragmentDoc}
  ${BasicUnitDetailsWithUwQuestionsFragmentFragmentDoc}
  ${BasicUnitDetailsWithUnitLevelCoveragesFragmentFragmentDoc}
`;
export const PolicySelectedQuotePricingFragmentDoc = gql `
  fragment PolicySelectedQuotePricing on Policy {
    selectedQuotePricing {
      ...PricingFragment
    }
  }
  ${PricingFragmentFragmentDoc}
`;
export const NewBusinessPolicySummaryFragmentFragmentDoc = gql `
  fragment NewBusinessPolicySummaryFragment on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    ...PolicyOffersFragment
    ...PolicySelectedQuotePricing
    previousAddress {
      ...AddressFragment
    }
    internalTrackingSubcode
    priorClaims {
      fieldGroupLocator
      amount
      subjects {
        firstName
        lastName
      }
      source
      category
      date
      catastrophe
    }
    policyholder {
      ...PolicyholderFragment
      hasActivePolicies
    }
    ...PolicyLevelCoveragesFragment
    units {
      ...BasicUnitDetailsWithUnitLevelCoveragesFragment
    }
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${PolicyOffersFragmentFragmentDoc}
  ${PolicySelectedQuotePricingFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${PolicyholderFragmentFragmentDoc}
  ${PolicyLevelCoveragesFragmentFragmentDoc}
  ${BasicUnitDetailsWithUnitLevelCoveragesFragmentFragmentDoc}
`;
export const UnitDetailsAfterUpdatesFragmentDoc = gql `
  fragment UnitDetailsAfterUpdates on PolicyUnit {
    ...BasicUnitDetailsWithUnitLevelCoveragesFragment
    ...BasicUnitDetailsWithUWQuestionsFragment
  }
  ${BasicUnitDetailsWithUnitLevelCoveragesFragmentFragmentDoc}
  ${BasicUnitDetailsWithUwQuestionsFragmentFragmentDoc}
`;
export const NewBusinessPolicyUpdatedByEditMyPlanFragmentFragmentDoc = gql `
  fragment NewBusinessPolicyUpdatedByEditMyPlanFragment on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    ...PolicyOffersFragment
    ...PolicySelectedQuotePricing
    previousAddress {
      ...AddressFragment
    }
    priorClaims {
      fieldGroupLocator
      amount
      subjects {
        firstName
        lastName
      }
      source
      category
      date
      catastrophe
    }
    policyholder {
      ...PolicyholderFragment
      hasActivePolicies
    }
    ...PolicyLevelCoveragesFragment
    units {
      ...UnitDetailsAfterUpdates
    }
    policyLevelUnderwritingAnswers {
      animalBite
      conviction
      cancellationRenew {
        cancellationRenew
        reasonCancellationRenew
      }
    }
    policyLevelUnderwritingQuestions {
      fieldName
      default
      options
    }
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${PolicyOffersFragmentFragmentDoc}
  ${PolicySelectedQuotePricingFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${PolicyholderFragmentFragmentDoc}
  ${PolicyLevelCoveragesFragmentFragmentDoc}
  ${UnitDetailsAfterUpdatesFragmentDoc}
`;
export const ContinueQuotePolicyFragmentFragmentDoc = gql `
  fragment ContinueQuotePolicyFragment on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    ...PolicyOffersFragment
    ...PolicySelectedQuotePricing
    bookConversion {
      source
      previousPolicyId
    }
    startDateAfterUWReview
    productTypeName
    mainUnitType
    gotInsuranceScoreHit
    insuredDateOfBirth
    internalTrackingSubcode
    isEsigned
    isAgentsSignResponsibility
    isInternalAgency
    physicallyMailDocuments
    hasAnotherCoverTreePolicy
    hasAutoPolicy
    additionalInsured {
      adFirstName
      adLastName
      locator
      relationshipIndividual
    }
    priorInsuranceDetails {
      priorInsurance
      priorCarrierName
      priorPolicyExpirationDate
    }
    documents {
      ...DocumentFragment
    }
    previousAddress {
      ...AddressFragment
    }
    priorClaims {
      fieldGroupLocator
      amount
      subjects {
        firstName
        lastName
      }
      source
      category
      date
      catastrophe
    }
    policyholder {
      ...PolicyholderFragment
      hasActivePolicies
    }
    ...PolicyLevelCoveragesFragment
    units {
      ...UnitDetailsFragment
    }
    policyLevelUnderwritingAnswers {
      animalBite
      conviction
      cancellationRenew {
        cancellationRenew
        reasonCancellationRenew
      }
    }
    policyLevelUnderwritingQuestions {
      fieldName
      default
      options
    }
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
  ${PolicyOffersFragmentFragmentDoc}
  ${PolicySelectedQuotePricingFragmentDoc}
  ${DocumentFragmentFragmentDoc}
  ${AddressFragmentFragmentDoc}
  ${PolicyholderFragmentFragmentDoc}
  ${PolicyLevelCoveragesFragmentFragmentDoc}
  ${UnitDetailsFragmentFragmentDoc}
`;
export const NewBusinessPolicyWithInternalTrackingSubcodeFragmentDoc = gql `
  fragment NewBusinessPolicyWithInternalTrackingSubcode on Policy {
    ...NewBusinessPolicyCommonDetailsFragment
    internalTrackingSubcode
  }
  ${NewBusinessPolicyCommonDetailsFragmentFragmentDoc}
`;
export const UnderwritingStatusFragmentFragmentDoc = gql `
  fragment UnderwritingStatusFragment on UnderwritingStatus {
    decision
    notes
    decisionTimestamp
  }
`;
export const PaymentPlanFragmentFragmentDoc = gql `
  fragment PaymentPlanFragment on PaymentPlan {
    isAvailable
    discountRate
    pricing {
      ...PricingFragment
    }
    installments {
      dueDate
      fees
      premium
      taxes
    }
  }
  ${PricingFragmentFragmentDoc}
`;
export const AdditionalInterestFragmentFragmentDoc = gql `
  fragment AdditionalInterestFragment on AdditionalInterest {
    type
    accountNumber
    additionalInterestId
    city
    email
    lotUnit
    name
    state
    streetAddress
    zipCode
  }
`;
export const AdditionalInterestFragmentWithBillingFragmentDoc = gql `
  fragment AdditionalInterestFragmentWithBilling on AdditionalInterest {
    ...AdditionalInterestFragment
    isBilling
  }
  ${AdditionalInterestFragmentFragmentDoc}
`;
export const CustomizedPolicyPricesFragmentFragmentDoc = gql `
  fragment CustomizedPolicyPricesFragment on CustomizedPolicyPrices {
    policyLocator
    pricing {
      ...PricingFragment
    }
    effectiveDate
    revisionDependentAccessors
  }
  ${PricingFragmentFragmentDoc}
`;
export const DynamicQuestionsFragmentFragmentDoc = gql `
  fragment DynamicQuestionsFragment on DynamicQuestions {
    basicPolicyQuestions {
      fieldName
      label
      tooltip
    }
    priorClaimsQuestions {
      label
      fieldName
      type
      options
      visibleOnPickedOptions
    }
  }
`;
export const GetAutocompleteAddressDocument = gql `
  query GetAutocompleteAddress($searchText: String!) {
    getAutocompleteAddresses(searchText: $searchText) {
      address {
        addressLastLine
        addressNumber
        country
        formattedAddress
        mainAddressLine
        postCode
        state
        streetName
        city
      }
      units {
        formattedUnitAddress
        lotUnit
      }
    }
  }
`;
/**
 * __useGetAutocompleteAddressQuery__
 *
 * To run a query within a React component, call `useGetAutocompleteAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutocompleteAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutocompleteAddressQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetAutocompleteAddressQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetAutocompleteAddressDocument, options);
}
export function useGetAutocompleteAddressLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetAutocompleteAddressDocument, options);
}
export function useGetAutocompleteAddressSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetAutocompleteAddressDocument, options);
}
export const CheckAndAddPriorClaimDocument = gql `
  mutation CheckAndAddPriorClaim(
    $policyLocator: ID!
    $formerAddress: GeoCodeInput!
  ) {
    checkAndAddPriorClaim(
      policyLocator: $policyLocator
      formerAddress: $formerAddress
    ) {
      ...NewBusinessPolicyWithPriorClaimsFragment
    }
  }
  ${NewBusinessPolicyWithPriorClaimsFragmentFragmentDoc}
`;
/**
 * __useCheckAndAddPriorClaimMutation__
 *
 * To run a mutation, you first call `useCheckAndAddPriorClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckAndAddPriorClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkAndAddPriorClaimMutation, { data, loading, error }] = useCheckAndAddPriorClaimMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      formerAddress: // value for 'formerAddress'
 *   },
 * });
 */
export function useCheckAndAddPriorClaimMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CheckAndAddPriorClaimDocument, options);
}
export const ConsumerContinueQuoteDocument = gql `
  mutation ConsumerContinueQuote($payload: String!) {
    consumerContinueQuote(payload: $payload) {
      dynamicQuestions {
        ...DynamicQuestionsFragment
      }
      policy {
        ...ContinueQuotePolicyFragment
      }
    }
  }
  ${DynamicQuestionsFragmentFragmentDoc}
  ${ContinueQuotePolicyFragmentFragmentDoc}
`;
/**
 * __useConsumerContinueQuoteMutation__
 *
 * To run a mutation, you first call `useConsumerContinueQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumerContinueQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumerContinueQuoteMutation, { data, loading, error }] = useConsumerContinueQuoteMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useConsumerContinueQuoteMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(ConsumerContinueQuoteDocument, options);
}
export const CreateOrUpdateBasicPolicyDetailsWithHolderDocument = gql `
  mutation CreateOrUpdateBasicPolicyDetailsWithHolder(
    $policyInput: CreateOrUpdateBasicPolicyDetailsInput!
    $policyholderInput: CreateOrUpdatePolicyholderInput!
  ) {
    createOrUpdateBasicPolicyDetailsWithHolder(
      policyInput: $policyInput
      policyholderInput: $policyholderInput
    ) {
      ...NewBusinessPolicyCreatedFragment
    }
  }
  ${NewBusinessPolicyCreatedFragmentFragmentDoc}
`;
/**
 * __useCreateOrUpdateBasicPolicyDetailsWithHolderMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBasicPolicyDetailsWithHolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBasicPolicyDetailsWithHolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBasicPolicyDetailsWithHolderMutation, { data, loading, error }] = useCreateOrUpdateBasicPolicyDetailsWithHolderMutation({
 *   variables: {
 *      policyInput: // value for 'policyInput'
 *      policyholderInput: // value for 'policyholderInput'
 *   },
 * });
 */
export function useCreateOrUpdateBasicPolicyDetailsWithHolderMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateOrUpdateBasicPolicyDetailsWithHolderDocument, options);
}
export const CreateOrUpdateHubspotContactDocument = gql `
  mutation CreateOrUpdateHubspotContact(
    $input: CreateOrUpdateHubspotContactInput!
  ) {
    createOrUpdateHubspotContact(input: $input) {
      email
      hsContactId
    }
  }
`;
/**
 * __useCreateOrUpdateHubspotContactMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateHubspotContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateHubspotContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateHubspotContactMutation, { data, loading, error }] = useCreateOrUpdateHubspotContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateHubspotContactMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateOrUpdateHubspotContactDocument, options);
}
export const GetDynamicQuestionsDocument = gql `
  query GetDynamicQuestions(
    $policyUsage: PolicyUsage!
    $state: String!
    $effectiveDate: AWSDate!
  ) {
    getDynamicQuestions(
      policyUsage: $policyUsage
      state: $state
      effectiveDate: $effectiveDate
    ) {
      ...DynamicQuestionsFragment
    }
  }
  ${DynamicQuestionsFragmentFragmentDoc}
`;
/**
 * __useGetDynamicQuestionsQuery__
 *
 * To run a query within a React component, call `useGetDynamicQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDynamicQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDynamicQuestionsQuery({
 *   variables: {
 *      policyUsage: // value for 'policyUsage'
 *      state: // value for 'state'
 *      effectiveDate: // value for 'effectiveDate'
 *   },
 * });
 */
export function useGetDynamicQuestionsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetDynamicQuestionsDocument, options);
}
export function useGetDynamicQuestionsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetDynamicQuestionsDocument, options);
}
export function useGetDynamicQuestionsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetDynamicQuestionsDocument, options);
}
export const FetchUwDecisionAndGeneratePaymentPlansDocument = gql `
  query FetchUWDecisionAndGeneratePaymentPlans($policyLocator: ID!) {
    fetchUWDecisionAndGeneratePaymentPlans(policyLocator: $policyLocator) {
      forceAgentSignResponsibility
      underwritingDecision {
        ...UnderwritingStatusFragment
      }
      paymentPlans {
        annual {
          ...PaymentPlanFragment
        }
        semiAnnual {
          ...PaymentPlanFragment
        }
        monthly {
          ...PaymentPlanFragment
        }
        mortgageBill {
          ...PaymentPlanFragment
        }
      }
      additionalInterests {
        ...AdditionalInterestFragment
      }
    }
  }
  ${UnderwritingStatusFragmentFragmentDoc}
  ${PaymentPlanFragmentFragmentDoc}
  ${AdditionalInterestFragmentFragmentDoc}
`;
/**
 * __useFetchUwDecisionAndGeneratePaymentPlansQuery__
 *
 * To run a query within a React component, call `useFetchUwDecisionAndGeneratePaymentPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUwDecisionAndGeneratePaymentPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUwDecisionAndGeneratePaymentPlansQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useFetchUwDecisionAndGeneratePaymentPlansQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(FetchUwDecisionAndGeneratePaymentPlansDocument, options);
}
export function useFetchUwDecisionAndGeneratePaymentPlansLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(FetchUwDecisionAndGeneratePaymentPlansDocument, options);
}
export function useFetchUwDecisionAndGeneratePaymentPlansSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(FetchUwDecisionAndGeneratePaymentPlansDocument, options);
}
export const GeoCodeAddressDocument = gql `
  query GeoCodeAddress($address: GeoCodeInput!) {
    geoCodeAddress(address: $address) {
      communityName
      county
      formattedLocationAddress
      homeLocation
      latitude
      longitude
      state
    }
  }
`;
/**
 * __useGeoCodeAddressQuery__
 *
 * To run a query within a React component, call `useGeoCodeAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeoCodeAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeoCodeAddressQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useGeoCodeAddressQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GeoCodeAddressDocument, options);
}
export function useGeoCodeAddressLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GeoCodeAddressDocument, options);
}
export function useGeoCodeAddressSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GeoCodeAddressDocument, options);
}
export const GetBinderDocumentDocument = gql `
  query GetBinderDocument(
    $policyLocator: ID!
    $paymentSchedule: PaymentSchedule!
    $additionalInterests: [AdditionalInterestInput!]
  ) {
    getQuoteDocuments(
      policyLocator: $policyLocator
      paymentSchedule: $paymentSchedule
      additionalInterests: $additionalInterests
    ) {
      binderDocumentUrl
    }
  }
`;
/**
 * __useGetBinderDocumentQuery__
 *
 * To run a query within a React component, call `useGetBinderDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBinderDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBinderDocumentQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      paymentSchedule: // value for 'paymentSchedule'
 *      additionalInterests: // value for 'additionalInterests'
 *   },
 * });
 */
export function useGetBinderDocumentQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetBinderDocumentDocument, options);
}
export function useGetBinderDocumentLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetBinderDocumentDocument, options);
}
export function useGetBinderDocumentSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetBinderDocumentDocument, options);
}
export const GetDecPageDocument = gql `
  query GetDecPage($policyLocator: ID!) {
    getDecPage(policyLocator: $policyLocator)
  }
`;
/**
 * __useGetDecPageQuery__
 *
 * To run a query within a React component, call `useGetDecPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDecPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDecPageQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useGetDecPageQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetDecPageDocument, options);
}
export function useGetDecPageLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetDecPageDocument, options);
}
export function useGetDecPageSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetDecPageDocument, options);
}
export const GetExtraCoveragesPricesDocument = gql `
  query GetExtraCoveragesPrices($policyLocator: ID!) {
    getExtraCoveragePrices(policyLocator: $policyLocator) {
      prices {
        debrisRemoval
        earthquake
        enhancedCoverage
        equipmentBreakdown
        golfCarts
        identityFraud
        incidentalFarming
        lossAssessment
        mineSubsidence
        sinkhole
        tripCollision
        vacationRental
        waterBackupAndSumpOverflow
        residenceBurglary
        buildersRisk
        secondaryResidenceLiability
        vandalismOrMaliciousMischief
        windstormOrHailExclusion
        fortifiedRoofUpgrade
      }
    }
  }
`;
/**
 * __useGetExtraCoveragesPricesQuery__
 *
 * To run a query within a React component, call `useGetExtraCoveragesPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtraCoveragesPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtraCoveragesPricesQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useGetExtraCoveragesPricesQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetExtraCoveragesPricesDocument, options);
}
export function useGetExtraCoveragesPricesLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetExtraCoveragesPricesDocument, options);
}
export function useGetExtraCoveragesPricesSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetExtraCoveragesPricesDocument, options);
}
export const GetOtherStructureProtectionPriceDocument = gql `
  query GetOtherStructureProtectionPrice(
    $policyLocator: ID!
    $otherStructureDescription: String!
    $otherStructureValue: Float!
  ) {
    getOtherStructureProtectionPrice(
      policyLocator: $policyLocator
      otherStructureDescription: $otherStructureDescription
      otherStructureValue: $otherStructureValue
    )
  }
`;
/**
 * __useGetOtherStructureProtectionPriceQuery__
 *
 * To run a query within a React component, call `useGetOtherStructureProtectionPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherStructureProtectionPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherStructureProtectionPriceQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      otherStructureDescription: // value for 'otherStructureDescription'
 *      otherStructureValue: // value for 'otherStructureValue'
 *   },
 * });
 */
export function useGetOtherStructureProtectionPriceQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetOtherStructureProtectionPriceDocument, options);
}
export function useGetOtherStructureProtectionPriceLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetOtherStructureProtectionPriceDocument, options);
}
export function useGetOtherStructureProtectionPriceSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetOtherStructureProtectionPriceDocument, options);
}
export const GetCommunitiesDocument = gql `
  query GetCommunities($search: String!) {
    getParameters(type: CommunityName, search: $search)
  }
`;
/**
 * __useGetCommunitiesQuery__
 *
 * To run a query within a React component, call `useGetCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunitiesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCommunitiesQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetCommunitiesDocument, options);
}
export function useGetCommunitiesLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetCommunitiesDocument, options);
}
export function useGetCommunitiesSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetCommunitiesDocument, options);
}
export const GetManufacturersDocument = gql `
  query GetManufacturers($search: String!) {
    getParameters(type: Manufacturer, search: $search)
  }
`;
/**
 * __useGetManufacturersQuery__
 *
 * To run a query within a React component, call `useGetManufacturersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManufacturersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManufacturersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetManufacturersQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetManufacturersDocument, options);
}
export function useGetManufacturersLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetManufacturersDocument, options);
}
export function useGetManufacturersSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetManufacturersDocument, options);
}
export const GetPricedCustomizedPolicyDocument = gql `
  query GetPricedCustomizedPolicy(
    $policyLocator: ID!
    $effectiveDate: AWSDate!
    $policyLevelCoverages: PolicyLevelCoveragesInput!
    $unitLevelCoverages: UnitLevelInput!
  ) {
    getPricedCustomizedPolicy(
      policyLocator: $policyLocator
      effectiveDate: $effectiveDate
      policyLevelCoverages: $policyLevelCoverages
      unitLevelCoverages: $unitLevelCoverages
    ) {
      ...CustomizedPolicyPricesFragment
    }
  }
  ${CustomizedPolicyPricesFragmentFragmentDoc}
`;
/**
 * __useGetPricedCustomizedPolicyQuery__
 *
 * To run a query within a React component, call `useGetPricedCustomizedPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricedCustomizedPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricedCustomizedPolicyQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      effectiveDate: // value for 'effectiveDate'
 *      policyLevelCoverages: // value for 'policyLevelCoverages'
 *      unitLevelCoverages: // value for 'unitLevelCoverages'
 *   },
 * });
 */
export function useGetPricedCustomizedPolicyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetPricedCustomizedPolicyDocument, options);
}
export function useGetPricedCustomizedPolicyLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetPricedCustomizedPolicyDocument, options);
}
export function useGetPricedCustomizedPolicySuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetPricedCustomizedPolicyDocument, options);
}
export const GetQuoteDocumentsDocument = gql `
  query GetQuoteDocuments(
    $policyLocator: ID!
    $paymentSchedule: PaymentSchedule!
    $additionalInterests: [AdditionalInterestInput!]
  ) {
    getQuoteDocuments(
      policyLocator: $policyLocator
      paymentSchedule: $paymentSchedule
      additionalInterests: $additionalInterests
    ) {
      applicationDocumentUrl
      quoteProposalUrl
    }
  }
`;
/**
 * __useGetQuoteDocumentsQuery__
 *
 * To run a query within a React component, call `useGetQuoteDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuoteDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuoteDocumentsQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      paymentSchedule: // value for 'paymentSchedule'
 *      additionalInterests: // value for 'additionalInterests'
 *   },
 * });
 */
export function useGetQuoteDocumentsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetQuoteDocumentsDocument, options);
}
export function useGetQuoteDocumentsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetQuoteDocumentsDocument, options);
}
export function useGetQuoteDocumentsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetQuoteDocumentsDocument, options);
}
export const GetRoofDataDocument = gql `
  query GetRoofData($latitude: Float!, $longitude: Float!, $locCode: String) {
    getRoofData(latitude: $latitude, longitude: $longitude, locCode: $locCode) {
      roofCondition
      roofMaterial
      roofShape
    }
  }
`;
/**
 * __useGetRoofDataQuery__
 *
 * To run a query within a React component, call `useGetRoofDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoofDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoofDataQuery({
 *   variables: {
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      locCode: // value for 'locCode'
 *   },
 * });
 */
export function useGetRoofDataQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetRoofDataDocument, options);
}
export function useGetRoofDataLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetRoofDataDocument, options);
}
export function useGetRoofDataSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetRoofDataDocument, options);
}
export const GetValuableItemProtectionPriceDocument = gql `
  query GetValuableItemProtectionPrice(
    $policyLocator: ID!
    $personalizedValuableItem: PersonalPropertyType!
    $personalizedValuableName: String!
    $personalizedValuableValue: Float!
  ) {
    getValuableItemProtectionPrice(
      policyLocator: $policyLocator
      personalizedValuableItem: $personalizedValuableItem
      personalizedValuableName: $personalizedValuableName
      personalizedValuableValue: $personalizedValuableValue
    )
  }
`;
/**
 * __useGetValuableItemProtectionPriceQuery__
 *
 * To run a query within a React component, call `useGetValuableItemProtectionPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuableItemProtectionPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuableItemProtectionPriceQuery({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      personalizedValuableItem: // value for 'personalizedValuableItem'
 *      personalizedValuableName: // value for 'personalizedValuableName'
 *      personalizedValuableValue: // value for 'personalizedValuableValue'
 *   },
 * });
 */
export function useGetValuableItemProtectionPriceQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetValuableItemProtectionPriceDocument, options);
}
export function useGetValuableItemProtectionPriceLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetValuableItemProtectionPriceDocument, options);
}
export function useGetValuableItemProtectionPriceSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetValuableItemProtectionPriceDocument, options);
}
export const InitiatePolicyPurchaseDocument = gql `
  mutation InitiatePolicyPurchase(
    $policyLocator: ID!
    $paymentSchedule: PaymentSchedule!
    $paymentMethod: PaymentMethod!
    $lenderDetails: LenderDetailsInput
    $signResponsibilityChecked: Boolean
    $additionalInterests: [AdditionalInterestInput!]
  ) {
    initiatePolicyPurchase(
      policyLocator: $policyLocator
      paymentSchedule: $paymentSchedule
      paymentMethod: $paymentMethod
      lenderDetails: $lenderDetails
      signResponsibilityChecked: $signResponsibilityChecked
      additionalInterests: $additionalInterests
    ) {
      clientSecret
      succeeded
    }
  }
`;
/**
 * __useInitiatePolicyPurchaseMutation__
 *
 * To run a mutation, you first call `useInitiatePolicyPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiatePolicyPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiatePolicyPurchaseMutation, { data, loading, error }] = useInitiatePolicyPurchaseMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      paymentSchedule: // value for 'paymentSchedule'
 *      paymentMethod: // value for 'paymentMethod'
 *      lenderDetails: // value for 'lenderDetails'
 *      signResponsibilityChecked: // value for 'signResponsibilityChecked'
 *      additionalInterests: // value for 'additionalInterests'
 *   },
 * });
 */
export function useInitiatePolicyPurchaseMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(InitiatePolicyPurchaseDocument, options);
}
export const RemovePaymentQuoteDocument = gql `
  mutation RemovePaymentQuote($policyLocator: ID!) {
    removePaymentQuote(policyLocator: $policyLocator)
  }
`;
/**
 * __useRemovePaymentQuoteMutation__
 *
 * To run a mutation, you first call `useRemovePaymentQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePaymentQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePaymentQuoteMutation, { data, loading, error }] = useRemovePaymentQuoteMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *   },
 * });
 */
export function useRemovePaymentQuoteMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RemovePaymentQuoteDocument, options);
}
export const SaveCustomizedPolicyDocument = gql `
  mutation SaveCustomizedPolicy(
    $policyLocator: ID!
    $effectiveDate: AWSDate!
    $policyLevelCoverages: PolicyLevelCoveragesInput!
    $unitLevelCoverages: UnitLevelInput!
  ) {
    saveCustomizedPolicy(
      policyLocator: $policyLocator
      effectiveDate: $effectiveDate
      policyLevelCoverages: $policyLevelCoverages
      unitLevelCoverages: $unitLevelCoverages
    ) {
      ...NewBusinessPolicyUpdatedByEditMyPlanFragment
    }
  }
  ${NewBusinessPolicyUpdatedByEditMyPlanFragmentFragmentDoc}
`;
/**
 * __useSaveCustomizedPolicyMutation__
 *
 * To run a mutation, you first call `useSaveCustomizedPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCustomizedPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCustomizedPolicyMutation, { data, loading, error }] = useSaveCustomizedPolicyMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      effectiveDate: // value for 'effectiveDate'
 *      policyLevelCoverages: // value for 'policyLevelCoverages'
 *      unitLevelCoverages: // value for 'unitLevelCoverages'
 *   },
 * });
 */
export function useSaveCustomizedPolicyMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SaveCustomizedPolicyDocument, options);
}
export const SaveExtraCoveragesDocument = gql `
  mutation SaveExtraCoverages(
    $policyLocator: ID!
    $policyLevelExtraCoverages: SavePolicyLevelExtraCoveragesInput!
    $unitLevelExtraCoverages: [SaveUnitLevelExtraCoveragesInput!]!
  ) {
    saveExtraCoverages(
      policyLocator: $policyLocator
      policyLevelExtraCoverages: $policyLevelExtraCoverages
      unitLevelExtraCoverages: $unitLevelExtraCoverages
    ) {
      ...NewBusinessPolicyAfterQuoteSelectionFragment
    }
  }
  ${NewBusinessPolicyAfterQuoteSelectionFragmentFragmentDoc}
`;
/**
 * __useSaveExtraCoveragesMutation__
 *
 * To run a mutation, you first call `useSaveExtraCoveragesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveExtraCoveragesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveExtraCoveragesMutation, { data, loading, error }] = useSaveExtraCoveragesMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      policyLevelExtraCoverages: // value for 'policyLevelExtraCoverages'
 *      unitLevelExtraCoverages: // value for 'unitLevelExtraCoverages'
 *   },
 * });
 */
export function useSaveExtraCoveragesMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SaveExtraCoveragesDocument, options);
}
export const SaveInternalTrackingSubcodeDocument = gql `
  mutation SaveInternalTrackingSubcode($policyLocator: ID!, $subcode: String!) {
    saveInternalTrackingSubcode(
      policyLocator: $policyLocator
      subcode: $subcode
    ) {
      ...NewBusinessPolicyWithInternalTrackingSubcode
    }
  }
  ${NewBusinessPolicyWithInternalTrackingSubcodeFragmentDoc}
`;
/**
 * __useSaveInternalTrackingSubcodeMutation__
 *
 * To run a mutation, you first call `useSaveInternalTrackingSubcodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInternalTrackingSubcodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInternalTrackingSubcodeMutation, { data, loading, error }] = useSaveInternalTrackingSubcodeMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      subcode: // value for 'subcode'
 *   },
 * });
 */
export function useSaveInternalTrackingSubcodeMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SaveInternalTrackingSubcodeDocument, options);
}
export const SavePriorClaimsDocument = gql `
  mutation SavePriorClaims(
    $policyLocator: ID!
    $priorClaims: [PriorClaimInput!]
  ) {
    savePriorClaims(policyLocator: $policyLocator, priorClaims: $priorClaims) {
      ...NewBusinessPolicySummaryFragment
    }
  }
  ${NewBusinessPolicySummaryFragmentFragmentDoc}
`;
/**
 * __useSavePriorClaimsMutation__
 *
 * To run a mutation, you first call `useSavePriorClaimsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePriorClaimsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePriorClaimsMutation, { data, loading, error }] = useSavePriorClaimsMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      priorClaims: // value for 'priorClaims'
 *   },
 * });
 */
export function useSavePriorClaimsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SavePriorClaimsDocument, options);
}
export const SelectQuoteDocument = gql `
  mutation SelectQuote($locator: ID!) {
    selectQuote(locator: $locator) {
      ...NewBusinessPolicyAfterQuoteSelectionFragment
    }
  }
  ${NewBusinessPolicyAfterQuoteSelectionFragmentFragmentDoc}
`;
/**
 * __useSelectQuoteMutation__
 *
 * To run a mutation, you first call `useSelectQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectQuoteMutation, { data, loading, error }] = useSelectQuoteMutation({
 *   variables: {
 *      locator: // value for 'locator'
 *   },
 * });
 */
export function useSelectQuoteMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SelectQuoteDocument, options);
}
export const UpdatePhysicallyMailDocumentsDocument = gql `
  mutation UpdatePhysicallyMailDocuments(
    $policyLocator: ID!
    $physicallyMailDocuments: Boolean!
  ) {
    updatePhysicallyMailDocuments(
      policyLocator: $policyLocator
      physicallyMailDocuments: $physicallyMailDocuments
    ) {
      ...NewBusinessPolicySummaryFragment
      physicallyMailDocuments
    }
  }
  ${NewBusinessPolicySummaryFragmentFragmentDoc}
`;
/**
 * __useUpdatePhysicallyMailDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdatePhysicallyMailDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhysicallyMailDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhysicallyMailDocumentsMutation, { data, loading, error }] = useUpdatePhysicallyMailDocumentsMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      physicallyMailDocuments: // value for 'physicallyMailDocuments'
 *   },
 * });
 */
export function useUpdatePhysicallyMailDocumentsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdatePhysicallyMailDocumentsDocument, options);
}
export const UpdatePolicyholderDetailsDocument = gql `
  mutation UpdatePolicyholderDetails(
    $locator: ID!
    $input: UpdatePolicyholderDetailsInput!
  ) {
    updatePolicyholderDetails(locator: $locator, input: $input) {
      ...PolicyholderFragment
    }
  }
  ${PolicyholderFragmentFragmentDoc}
`;
/**
 * __useUpdatePolicyholderDetailsMutation__
 *
 * To run a mutation, you first call `useUpdatePolicyholderDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePolicyholderDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePolicyholderDetailsMutation, { data, loading, error }] = useUpdatePolicyholderDetailsMutation({
 *   variables: {
 *      locator: // value for 'locator'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePolicyholderDetailsMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdatePolicyholderDetailsDocument, options);
}
export const UpdateUnderwritingAnswersDocument = gql `
  mutation UpdateUnderwritingAnswers(
    $policyLocator: ID!
    $policyLevelUW: UnderwritingPolicyAnswersInput!
    $unitLevelUW: [UnderwritingUnitAnswersInput!]!
  ) {
    updateUnderwritingAnswers(
      policyLocator: $policyLocator
      policyLevelUW: $policyLevelUW
      unitLevelUW: $unitLevelUW
    ) {
      ...NewBusinessPolicyWithUWQuestions
    }
  }
  ${NewBusinessPolicyWithUwQuestionsFragmentDoc}
`;
/**
 * __useUpdateUnderwritingAnswersMutation__
 *
 * To run a mutation, you first call `useUpdateUnderwritingAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUnderwritingAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUnderwritingAnswersMutation, { data, loading, error }] = useUpdateUnderwritingAnswersMutation({
 *   variables: {
 *      policyLocator: // value for 'policyLocator'
 *      policyLevelUW: // value for 'policyLevelUW'
 *      unitLevelUW: // value for 'unitLevelUW'
 *   },
 * });
 */
export function useUpdateUnderwritingAnswersMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateUnderwritingAnswersDocument, options);
}
export const ValidateEmailDocument = gql `
  query ValidateEmail($email: AWSEmail!) {
    validateEmail(email: $email) {
      email
      autocorrect
      deliverability
      qualityScore
    }
  }
`;
/**
 * __useValidateEmailQuery__
 *
 * To run a query within a React component, call `useValidateEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useValidateEmailQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ValidateEmailDocument, options);
}
export function useValidateEmailLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ValidateEmailDocument, options);
}
export function useValidateEmailSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(ValidateEmailDocument, options);
}
